// A lazy route chunk can 404 after a new deploy replaces it with a different hash while a
// user still has the old page open. Reloading picks up the new build, but only once per
// session — if the reload doesn't fix it (offline, broken deploy), looping forever would
// just spin the tab instead of showing the user anything.
const RELOAD_FLAG = 'codisoc:chunk-reload-attempted';

export const CHUNK_ERROR_PATTERN =
  /dynamically imported module|importing a module script failed|failed to fetch/i;

export const hasAttemptedChunkReload = () => {
  try {
    return sessionStorage.getItem(RELOAD_FLAG) === '1';
  } catch {
    return false;
  }
};

export const reloadOnChunkErrorOnce = (): boolean => {
  if (hasAttemptedChunkReload()) return false;
  try {
    sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch {
    // sessionStorage unavailable (private mode / blocked) — reload anyway, just without the guard
  }
  window.location.reload();
  return true;
};
